import React, { useCallback } from 'react';
import { useParams } from 'react-router';
import { saveAs } from 'file-saver';

import { StaticContentClient } from 'utils';
import { useTranslations } from 'utils/hooks';

import classes from './DownloadButton.module.scss';

const DownloadButton = () => {
  const translations = useTranslations();
  const { bu, lang, section } = useParams();

  /**
   * savePdf
   * Save the file generated blob on user's native file system
   * @param {ArrayBuffer} arrayBuffer Raw buffer data from the content of response
   * @return {void}
   */
  const savePdf = useCallback(
    blob => {
      const pdf = new Blob([blob], { type: 'application/pdf' });

      const firstLetter = section.charAt(0).toUpperCase();
      const trimmedFirstLetter = section.slice(1);
      saveAs(pdf, `${firstLetter}${trimmedFirstLetter}.pdf`);
    },
    [section]
  );

  const downloadPdf = useCallback(async () => {
    const result = await StaticContentClient.downloadPdf({
      bu,
      lang,
      name: section
    });

    const pdfBlob = result.getData();
    if (result.isNotEmpty()) {
      savePdf(pdfBlob);
    }
  }, [bu, lang, savePdf, section]);

  return (
    <div className={classes.DownloadButton}>
      <button onClick={downloadPdf}>{translations('downloadPdf')}</button>
    </div>
  );
};

export default DownloadButton;
